module.exports = __webpack_public_path__ + "img/patru@3x.41351305.png";